<div class="login-popup-main {{admin}}">
    <div class="login-popup">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="login-container">
            <div class="title-container">
                <div class="title">
                    <h3>{{'login.signIn' | translate | uppercase}}</h3>
                    <h3 *ngIf="dataDialog" [ngStyle]="{'color':'red'}">{{dataDialog.message}}</h3>
                </div>
            </div>
            <form [formGroup]="loginForm!" novalidate>
                <div class="username-password">
                    <label>{{'login.email' | translate}}</label>
                    <input
                        formControlName="email"
                        id="email"
                        class="form-control"
                        type="email"
                        required
                        [ngStyle]="loginForm!.controls['email'].invalid && (loginForm!.controls['email'].dirty ||loginForm!.controls['email'].touched) && loginForm!.controls['email'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                        autocomplete="email"
                        name="email"
                    /><br />
                    <br />
                    <label>{{'login.password' | translate}}</label>
                    <input
                        formControlName="password"
                        id="password"
                        class="form-control"
                        required
                        name="password"
                        [ngStyle]="loginForm!.controls['password'].invalid && (loginForm!.controls['password'].dirty ||loginForm!.controls['password'].touched) && loginForm!.controls['password'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                        type="password"
                        name="password"
                        autocomplete="current-password"
                    /><br />
                    <br />
                </div>
            </form>

            <div class="login-button">
                <button (click)="login('/')" [disabled]="!loginForm?.valid">{{'login.signIn' | translate}}</button>
            </div>

            <div class="registration-forgot-main-container">
                <div class="registration-forgot-container">
                    <div class="registration">
                        <a (click)="openRegistration()"><p>{{'login.signUp' | translate}}</p></a>
                    </div>
                    <div class="forgot-password">
                        <a (click)="openForgotPassword()"><p>{{'login.forgotPassword' | translate}}</p></a>
                    </div>
                </div>
            </div>
            <div [ngStyle]="{'color': 'red'}">{{errorLoginMessage}}</div>
            <div class="social-login"></div>
        </div>
    </div>
</div>

<!--For only login applications-->
<div class="login-only-container {{admin}}">
    <div class="title-only-container">
        <div class="title-only">
            <h3>{{'login.signIn' | translate | uppercase}}</h3>
        </div>
    </div>
    <form [formGroup]="loginForm!" novalidate>
        <div class="username-only-password">
            <label>{{'login.email' | translate}}</label>
            <input
                formControlName="email"
                id="email"
                class="form-control"
                type="email"
                required
                [ngStyle]="loginForm!.controls['email'].invalid && (loginForm!.controls['email'].dirty ||loginForm!.controls['email'].touched) && loginForm!.controls['email'].errors?.['required'] && {'border':'1px solid red'}"
                autofocus
                autocomplete="email"
                name="email"
            /><br />
            <br />
            <label>{{'login.password' | translate}}</label>
            <input
                formControlName="password"
                id="password"
                class="form-control"
                required
                [ngStyle]="loginForm!.controls['password'].invalid && (loginForm!.controls['password'].dirty ||loginForm!.controls['password'].touched) && loginForm!.controls['password'].errors?.['required'] && {'border':'1px solid red'}"
                autofocus
                type="password"
                name="password"
                autocomplete="current-password"
            /><br />
            <br />
        </div>
    </form>

    <div class="login-only-button">
        <button (click)="login(redirectUrl)" [disabled]="!loginForm?.valid">{{'login.signIn' | translate}}</button>
    </div>
    <div class="registration-forgot-only-main-container">
        <div class="registration-forgot-only-container">
            <div class="forgot-password">
                <a (click)="openForgotPassword()"><p>{{'login.forgotPassword' | translate}}</p></a>
            </div>
        </div>
    </div>
    <div [ngStyle]="{'color': 'red'}">{{errorLoginMessage}}</div>
</div>
